import React, { useState, useEffect } from "react";
import classes from "./RemovePayoutMethod.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../../stories/Button/Button";
import { Row, Col } from "react-bootstrap";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import { Payment } from "../../../../../constant/imagePath";

export const RemovePayoutMethodModal = ({ show, setShow }) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  return (
    <>
      <style>{`
              @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 90% !important;
              margin: 0px 10%;
            }
        }
            @media screen and (max-width: 768px) {
                .${modalClasses.body} {
                  padding:0px 24px;
                }
                .${modalClasses.header} {
                    margin:24px;
                  }
            }

      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{
          marginBottom: "0px",
          paddingBottom: "16px",
          display: "flex",
          justifyContent: "center",
        }}
        borderRadius={"20px"}
        footerStyles={
          isMobile
            ? {
                padding: "16px 24px",
                margin: "0px",
              }
            : {
                padding: "16px 32px",
                margin: "0px",
              }
        }
        width={"468px"}
        header={
          <div>
            <img src={Payment} alt="..." />
          </div>
        }
      >
        <div
          className={[
            isMobile ? classes.pb24 : classes.pb32,
            classes.textcenter,
          ].join(" ")}
        >
          <h4
            className={[classes.mb8].join(" ")}
            style={
              isMobile
                ? {
                    ...Fonts.h3,
                    color: Colors.neutralShadesOfNero,
                    fontSize: "24px",
                    lineHeight: "32px",
                  }
                : {
                    ...Fonts.h4,
                    color: Colors.neutralShadesOfNero,
                    fontSize: "26px",
                  }
            }
          >
            Remove payout method
          </h4>
          <p style={{ ...Fonts.p1, fontSize: "16px", lineHeight: "24px" }}>
            Are you sure you want to remove this payout method?
          </p>
          <Row className={[classes.btndiv].join(" ")}>
            <Col md={6} className={[classes.mb8Onmd].join(" ")}>
              <Button
                label={`Cancel`}
                primary={false}
                size={"Large"}
                customStyle={{
                  width: "100%",
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
                onClick={() => setShow(false)}
              />
            </Col>
            <Col md={6}>
              <Button
                label={`Confirm`}
                primary={true}
                size={"Large"}
                customStyle={{
                  width: "100%",
                  ...Fonts.b2,
                  lineHeight: "20px",
                }}
                onClick={() => setShow(false)}
              />
            </Col>
          </Row>
        </div>
      </ModalSkeleton>
    </>
  );
};
